//RAW DATA
export const GET_SELECTED_SEALEDSYSTEM_ID_DATA = 'GET_SEALEDSYSTEM_ID_DATA';
export const ERROR_SELECTED_SEALEDSYSTEM_ID_DATA = 'ERROR_SEALEDSYSTEM_ID_DATA';
export const CLEAR_SELECTED_SEALEDSYSTEM_ID_DATA = 'CLEAR_SEALEDSYSTEM_ID_DATA';
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS';
export const SUBMIT_FAIL = 'SUBMIT_FAIL';